import React, { useState, useEffect, useMemo } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Tabs } from "antd";
import CustomerDetail from "./Customer/CustomerDetail";
import TotalCustomer from "./Customer/TotalCustomer";
import InternalCustomerDetail from "./Customer/InternalCustomerDetail";
const { TabPane } = Tabs;
import { getProfile } from "../../core/api/auth";

const Customer = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [forcedTabKey, setForcedTabKey] = useState(null);
  const [user, setUser] = useState(null);
  const [userLoading, setUserLoading] = useState(true);
  

  // Define tab paths mapping using useMemo to prevent recreation on each render
  const tabKeyToPath = useMemo(
    () => ({
      1: "customer-detail",
      2: "customer",
      3: "total-customer",
    }),
    []
  );

  // Create reverse mapping from path to key
  const pathToTabKey = useMemo(() => {
    return Object.entries(tabKeyToPath).reduce((acc, [key, path]) => {
      acc[path] = key;
      return acc;
    }, {});
  }, [tabKeyToPath]);

  // Get current path from URL - extract base path without ID
  const pathParts = location.pathname.split("/");
  const currentPath = pathParts[1]; // Get the first part after the leading slash
  
  // Check if we have an ID in the URL (for customer-detail/:id)
  const hasId = pathParts.length > 2 && currentPath === "customer-detail" && pathParts[2];
  const customerId = hasId ? pathParts[2] : null;

  // Determine active tab key based on current path
  let computedKey;
  
  // Handle special case for customer-detail with ID
  if (currentPath === "customer-detail") {
    computedKey = "1"; // Customer tab
  } else {
    computedKey = pathToTabKey[currentPath] || "2";
  }
  
  const activeTabKey = forcedTabKey || computedKey;

  // Set default tab on initial load if not on a specific tab path
  useEffect(() => {
    // Only redirect if we're not on a valid path and not on a detail page with ID
    if (!Object.values(tabKeyToPath).includes(currentPath) && !hasId) {
      navigate(`/customer`, { replace: true });
    }
  }, [currentPath, navigate, tabKeyToPath, hasId]);

  // Handle tab change
  const handleTabChange = (key) => {
    setForcedTabKey(null);
    navigate(`/${tabKeyToPath[key]}`);
  };

 
  return (
    <div className="page-wrapper">
      <Tabs activeKey={activeTabKey} onChange={handleTabChange} className="p-2">
      <TabPane tab="Total Customer" key="2">
        <TotalCustomer />
        </TabPane>
        <TabPane tab="Customer" key="1">
          <InternalCustomerDetail customerId={customerId} />
        </TabPane>
       
      </Tabs>
    </div>
  );
};

export default Customer;
